import styles from "./ValueSelector.module.scss";

export default function ValueSelector({
  values,
  onCheckValueChange
}) {
  return (
    <div className={styles.container}>
      {values.map(val => (
        <button
          key={val.label}
          className={`${styles.option} ${val.checked ? styles.active : ''}`}
          onClick={() => { onCheckValueChange(val.label, !val.checked) }}
        >
          {val.label}
        </button>
      ))}
    </div>
  )
}
